"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _ConfirmUserResponse = _interopRequireDefault(require("../model/ConfirmUserResponse"));

var _CreateUserResponse = _interopRequireDefault(require("../model/CreateUserResponse"));

var _DeleteUserResponse = _interopRequireDefault(require("../model/DeleteUserResponse"));

var _ForgotMyPassword = _interopRequireDefault(require("../model/ForgotMyPassword"));

var _HTTPBadRequestError = _interopRequireDefault(require("../model/HTTPBadRequestError"));

var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));

var _Languages = _interopRequireDefault(require("../model/Languages"));

var _PatchUser = _interopRequireDefault(require("../model/PatchUser"));

var _PatchUserResponse = _interopRequireDefault(require("../model/PatchUserResponse"));

var _ResendUserVerificationEmailResponse = _interopRequireDefault(require("../model/ResendUserVerificationEmailResponse"));

var _ResetPasswordConfirm = _interopRequireDefault(require("../model/ResetPasswordConfirm"));

var _ResetPasswordConfirmResponse = _interopRequireDefault(require("../model/ResetPasswordConfirmResponse"));

var _ResetPasswordResponse = _interopRequireDefault(require("../model/ResetPasswordResponse"));

var _ResetUserPassword = _interopRequireDefault(require("../model/ResetUserPassword"));

var _SuspendUserResponse = _interopRequireDefault(require("../model/SuspendUserResponse"));

var _User = _interopRequireDefault(require("../model/User"));

var _UserConfirmation = _interopRequireDefault(require("../model/UserConfirmation"));

var _UserResponse = _interopRequireDefault(require("../model/UserResponse"));

var _UsersResponse = _interopRequireDefault(require("../model/UsersResponse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
* User service.
* @module api/UserApi
* @version integration550
*/
var UserApi = /*#__PURE__*/function () {
  /**
  * Constructs a new UserApi. 
  * @alias module:api/UserApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function UserApi(apiClient) {
    _classCallCheck(this, UserApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Callback function to receive the result of the confirmUser operation.
   * @callback module:api/UserApi~confirmUserCallback
   * @param {String} error Error message, if any.
   * @param {module:model/ConfirmUserResponse} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Confirm a user
   * @param {String} userId 
   * @param {module:model/UserConfirmation} userConfirmation 
   * @param {module:api/UserApi~confirmUserCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/ConfirmUserResponse}
   */


  _createClass(UserApi, [{
    key: "confirmUser",
    value: function confirmUser(userId, userConfirmation, callback) {
      var postBody = userConfirmation; // verify the required parameter 'userId' is set

      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling confirmUser");
      } // verify the required parameter 'userConfirmation' is set


      if (userConfirmation === undefined || userConfirmation === null) {
        throw new Error("Missing the required parameter 'userConfirmation' when calling confirmUser");
      }

      var pathParams = {
        'user_id': userId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ConfirmUserResponse["default"];
      return this.apiClient.callApi('/users/{user_id}/confirm', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the createUser operation.
     * @callback module:api/UserApi~createUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CreateUserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a user
     * @param {module:model/User} user 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {Boolean} opts.skipVerification  (default to false)
     * @param {module:api/UserApi~createUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CreateUserResponse}
     */

  }, {
    key: "createUser",
    value: function createUser(user, opts, callback) {
      opts = opts || {};
      var postBody = user; // verify the required parameter 'user' is set

      if (user === undefined || user === null) {
        throw new Error("Missing the required parameter 'user' when calling createUser");
      }

      var pathParams = {};
      var queryParams = {
        'account_id': opts['accountId'],
        'skip_verification': opts['skipVerification']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _CreateUserResponse["default"];
      return this.apiClient.callApi('/users', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the deleteUser operation.
     * @callback module:api/UserApi~deleteUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DeleteUserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a user
     * @param {String} userId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/UserApi~deleteUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DeleteUserResponse}
     */

  }, {
    key: "deleteUser",
    value: function deleteUser(userId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'userId' is set

      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling deleteUser");
      }

      var pathParams = {
        'user_id': userId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _DeleteUserResponse["default"];
      return this.apiClient.callApi('/users/{user_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the forgotMyPassword operation.
     * @callback module:api/UserApi~forgotMyPasswordCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResetPasswordResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Forgot my password
     * Sends an email containing a reset password token.
     * @param {module:model/ForgotMyPassword} forgotMyPassword 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:model/Languages} opts.language 
     * @param {module:api/UserApi~forgotMyPasswordCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResetPasswordResponse}
     */

  }, {
    key: "forgotMyPassword",
    value: function forgotMyPassword(_forgotMyPassword, opts, callback) {
      opts = opts || {};
      var postBody = _forgotMyPassword; // verify the required parameter 'forgotMyPassword' is set

      if (_forgotMyPassword === undefined || _forgotMyPassword === null) {
        throw new Error("Missing the required parameter 'forgotMyPassword' when calling forgotMyPassword");
      }

      var pathParams = {};
      var queryParams = {
        'account_id': opts['accountId'],
        'language': opts['language']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ResetPasswordResponse["default"];
      return this.apiClient.callApi('/users/forgot-my-password', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getSelfUser operation.
     * @callback module:api/UserApi~getSelfUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show my user details
     * @param {module:api/UserApi~getSelfUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */

  }, {
    key: "getSelfUser",
    value: function getSelfUser(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _UserResponse["default"];
      return this.apiClient.callApi('/users/self', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getUser operation.
     * @callback module:api/UserApi~getUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show a user details
     * @param {String} userId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/UserApi~getUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */

  }, {
    key: "getUser",
    value: function getUser(userId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'userId' is set

      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getUser");
      }

      var pathParams = {
        'user_id': userId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _UserResponse["default"];
      return this.apiClient.callApi('/users/{user_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the listUsers operation.
     * @callback module:api/UserApi~listUsersCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UsersResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show all users in my account
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {Number} opts.page  (default to 1)
     * @param {Number} opts.perPage  (default to 50)
     * @param {Boolean} opts.withCount  (default to false)
     * @param {String} opts.filter Valid Terms:   - `email`   - `status`  Valid Operators:   - `==`  Query separator:   - `;`
     * @param {module:api/UserApi~listUsersCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UsersResponse}
     */

  }, {
    key: "listUsers",
    value: function listUsers(opts, callback) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'account_id': opts['accountId'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_count': opts['withCount'],
        'filter': opts['filter']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _UsersResponse["default"];
      return this.apiClient.callApi('/users', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the patchUser operation.
     * @callback module:api/UserApi~patchUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PatchUserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update a user
     * @param {String} userId 
     * @param {module:model/PatchUser} patchUser 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/UserApi~patchUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PatchUserResponse}
     */

  }, {
    key: "patchUser",
    value: function patchUser(userId, _patchUser, opts, callback) {
      opts = opts || {};
      var postBody = _patchUser; // verify the required parameter 'userId' is set

      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling patchUser");
      } // verify the required parameter 'patchUser' is set


      if (_patchUser === undefined || _patchUser === null) {
        throw new Error("Missing the required parameter 'patchUser' when calling patchUser");
      }

      var pathParams = {
        'user_id': userId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _PatchUserResponse["default"];
      return this.apiClient.callApi('/users/{user_id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the resendUserVerification operation.
     * @callback module:api/UserApi~resendUserVerificationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResendUserVerificationEmailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Resend the user verification email
     * @param {String} userId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/UserApi~resendUserVerificationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResendUserVerificationEmailResponse}
     */

  }, {
    key: "resendUserVerification",
    value: function resendUserVerification(userId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'userId' is set

      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling resendUserVerification");
      }

      var pathParams = {
        'user_id': userId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ResendUserVerificationEmailResponse["default"];
      return this.apiClient.callApi('/users/{user_id}/resend-verification-email', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the resetPasswordConfirm operation.
     * @callback module:api/UserApi~resetPasswordConfirmCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResetPasswordConfirmResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Reset password confirmation
     * Change a user password if the reset password token is valid for that user.
     * @param {module:model/ResetPasswordConfirm} resetPasswordConfirm 
     * @param {module:api/UserApi~resetPasswordConfirmCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResetPasswordConfirmResponse}
     */

  }, {
    key: "resetPasswordConfirm",
    value: function resetPasswordConfirm(_resetPasswordConfirm, callback) {
      var postBody = _resetPasswordConfirm; // verify the required parameter 'resetPasswordConfirm' is set

      if (_resetPasswordConfirm === undefined || _resetPasswordConfirm === null) {
        throw new Error("Missing the required parameter 'resetPasswordConfirm' when calling resetPasswordConfirm");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ResetPasswordConfirmResponse["default"];
      return this.apiClient.callApi('/users/reset-password-confirm', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the resetSelfPassword operation.
     * @callback module:api/UserApi~resetSelfPasswordCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResetPasswordResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Reset my password
     * Sends an email containing a reset password token.
     * @param {module:api/UserApi~resetSelfPasswordCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResetPasswordResponse}
     */

  }, {
    key: "resetSelfPassword",
    value: function resetSelfPassword(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ResetPasswordResponse["default"];
      return this.apiClient.callApi('/users/self/reset-password', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the resetUserPassword operation.
     * @callback module:api/UserApi~resetUserPasswordCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResetPasswordResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Reset a user password
     * Sends an email containing a reset password token.
     * @param {Number} userId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:model/ResetUserPassword} opts.resetUserPassword 
     * @param {module:api/UserApi~resetUserPasswordCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResetPasswordResponse}
     */

  }, {
    key: "resetUserPassword",
    value: function resetUserPassword(userId, opts, callback) {
      opts = opts || {};
      var postBody = opts['resetUserPassword']; // verify the required parameter 'userId' is set

      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling resetUserPassword");
      }

      var pathParams = {
        'user_id': userId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ResetPasswordResponse["default"];
      return this.apiClient.callApi('/users/{user_id}/reset-password', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the suspendUser operation.
     * @callback module:api/UserApi~suspendUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SuspendUserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Suspend a user
     * @param {Number} userId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/UserApi~suspendUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SuspendUserResponse}
     */

  }, {
    key: "suspendUser",
    value: function suspendUser(userId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'userId' is set

      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling suspendUser");
      }

      var pathParams = {
        'user_id': userId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _SuspendUserResponse["default"];
      return this.apiClient.callApi('/users/{user_id}/suspend', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the unsuspendUser operation.
     * @callback module:api/UserApi~unsuspendUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SuspendUserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Unsuspend a user
     * @param {Number} userId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/UserApi~unsuspendUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SuspendUserResponse}
     */

  }, {
    key: "unsuspendUser",
    value: function unsuspendUser(userId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'userId' is set

      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling unsuspendUser");
      }

      var pathParams = {
        'user_id': userId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _SuspendUserResponse["default"];
      return this.apiClient.callApi('/users/{user_id}/unsuspend', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);

  return UserApi;
}();

exports["default"] = UserApi;